import React from 'react';
import LocalizedText from "../../presentational/LocalizedText";
import LoadIndicator from "../../presentational/LoadIndicator";

interface VerifyEmailProps {
  serverError: string;
  isLoading: boolean;
}

const VerifyEmail: React.FC<VerifyEmailProps> = ({ serverError, isLoading }) => {

  return (
    <div className="login-action">
      <h1>
        <LocalizedText textKey="participant-login-verify-email-title" />
      </h1>
      {
        serverError && (
          <p className="server-error">{serverError}</p>
        )
      }
      {
        isLoading && (<LoadIndicator />)
      }
      {
        !isLoading && !serverError ? (
          <p>
            <LocalizedText textKey="participant-login-verify-email-confirmation" />
          </p>
        ) : null
      }
    </div>
  )
}

export default VerifyEmail